export const EXAM_DETAIL_LABEL_TYPE = {
  EEG_TYPE: 'EegType',
  ONCOLOGIC: 'Oncologic'
}

export const EXAM_PANEL_LABEL_TYPES = new Set([
  EXAM_DETAIL_LABEL_TYPE.EEG_TYPE
])

export function filterExamPanelLabels(labels) {
  if (!labels || !labels.length) {
    return []
  }

  return labels.filter(
    (label) =>
      EXAM_PANEL_LABEL_TYPES.has(label.type) && Boolean(label.label && label.label.trim())
  )
}

export function resolveExamPanelLabelClassName(type) {
  if (type === EXAM_DETAIL_LABEL_TYPE.ONCOLOGIC) {
    return 'exam-detail-label exam-detail-label--oncologic'
  }

  if (type === EXAM_DETAIL_LABEL_TYPE.EEG_TYPE) {
    return 'exam-detail-label exam-detail-label--eeg'
  }

  return 'exam-detail-label'
}
